import useAllBrands from '@/lib/hook/useAllBrands'

export const parent_id = 9999999

function alphabetPosition(text): number {
  let result = ''
  for (let i = 0; i < text.length; i++) {
    const code = text.toUpperCase().charCodeAt(i)
    if (code > 64 && code < 91) result += code - 64 + ' '
  }

  return Number(result.slice(0, result.length - 1))
}

const useBrandsMenu = () => {
  const { data, isLoading: loading } = useAllBrands()

  const mainCat = [
    { category_id: parent_id + 1, category: '0-9', parent_id, mode: 'list' },
    { category_id: parent_id + 2, category: 'A-B', parent_id, mode: 'list' },
    { category_id: parent_id + 3, category: 'C-D', parent_id, mode: 'list' },
    { category_id: parent_id + 4, category: 'E-F', parent_id, mode: 'list' },
    { category_id: parent_id + 5, category: 'G-H', parent_id, mode: 'list' },
    { category_id: parent_id + 6, category: 'I-J', parent_id, mode: 'list' },
    { category_id: parent_id + 7, category: 'K-L', parent_id, mode: 'list' },
    { category_id: parent_id + 8, category: 'M-N', parent_id, mode: 'list' },
    { category_id: parent_id + 9, category: 'O-P', parent_id, mode: 'list' },
    { category_id: parent_id + 10, category: 'Q-R', parent_id, mode: 'list' },
    { category_id: parent_id + 11, category: 'S-T', parent_id, mode: 'list' },
    { category_id: parent_id + 12, category: 'U-V', parent_id, mode: 'list' },
    { category_id: parent_id + 13, category: 'W-X', parent_id, mode: 'list' },
    { category_id: parent_id + 14, category: 'Y-Z', parent_id, mode: 'list' },
  ].map((b, position) => ({ ...b, position }))

  if (!loading && !!data) {
    data.brands.forEach(brand => {
      // Marques sans nom (variant null, donnees CS-Cart incompletes) : pas de
      // lettre -> on les exclut du menu (sinon brand.variant.substr crashe).
      if (!brand.variant) return
      const letterPosition = alphabetPosition(brand.variant.substr(0, 1))
      const index = Math.ceil(letterPosition / 2) + 1
      mainCat.push({
        // @ts-ignore
        category_id: String(brand.variant_id),
        variant_id: String(brand.variant_id),
        category: String(brand.variant),
        feature_id: String(brand.feature_id),
        seo_name: String(brand.seo_name),
        parent_id: parent_id + index,
        isBrand: true,
      })
    })
  }

  return [...mainCat]
}

export default useBrandsMenu
